module.exports = __webpack_public_path__ + "static/media/others2.9bfefec3.png";